import React from "react";
import { withStyles } from "@material-ui/core";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";

export const MaterialStepper = withStyles({
  root: {
    padding: "0",
  }
})(Stepper);

export const MaterialStep = withStyles((theme) => ({
  root: {
    "& .MuiStepLabel-iconContainer svg" : {
      width: "40px",
      height: "40px"
    },
    "& .MuiStepIcon-active" : {
      color: theme.custom.stepper.activeColor
    },
    "& .MuiStepIcon-completed" : {
      color: theme.custom.stepper.completedColor
    },
    "& .MuiStepLabel-label" : {
      fontSize: "14px"
    }
  }
}))(Step);


